import React from 'react';

import { Table } from '../../../../components/Table/Table';
import { tgSessionsThArray } from '../../../../utils/constants/th_arrays';
import { type TgSession } from '../../../../redux/types/TgSessionsTypes';
import SessionActions from './SessionActions';
import { formatDate, maskCard, statusInfo } from './helpers';
import styles from '../TgSessions.module.css';

const SessionsTable = ({ sessions }: { sessions: TgSession[] }) => {
  if (sessions.length === 0) {
    return <div className={styles.empty}>Аккаунтов пока нет — нажмите «Добавить аккаунт».</div>;
  }
  return (
    <Table
      tableId='trader-tg-sessions'
      thArray={tgSessionsThArray}
      tdArray={sessions.map((session) => {
        const status = statusInfo(session);
        return [
          {
            element: (
              <div className={styles.account}>
                <b>{session.label || session.phone}</b>
                <span className={styles.accountPhone}>
                  {session.phone}
                  {session.username ? ` · @${session.username}` : ''}
                </span>
              </div>
            ),
            style: { width: '22%' },
          },
          {
            element: (
              <div>
                <span className={`${styles.status} ${styles[status.tone]}`}>{status.label}</span>
                {session.last_error && <div className={styles.error}>{session.last_error}</div>}
              </div>
            ),
            style: { width: '16%' },
          },
          {
            element: (
              <div className={styles.requisites}>
                {session.requisites_display.length === 0 ? (
                  <span className={styles.muted}>Все реквизиты банка</span>
                ) : (
                  session.requisites_display.map((requisite) => (
                    <span key={requisite.id}>
                      {requisite.bank} {maskCard(requisite.account_number)}
                      {requisite.tag ? ` · ${requisite.tag}` : ''}
                    </span>
                  ))
                )}
              </div>
            ),
            style: { width: '26%' },
          },
          { element: formatDate(session.last_seen_at), style: { width: '14%' } },
          { element: <SessionActions session={session} />, style: { width: '22%' } },
        ];
      })}
    >
      {' '}
    </Table>
  );
};

export default SessionsTable;
